import { alertReducerObject } from '@calendly/alert'
import { onetrustReducerObject } from '@calendly/onetrust/redux'

import { reducer as billingReducer } from 'features/billing'
import { paymentLinkFormReducer } from 'features/payment_link'

import passthrough from './core/passthrough'
import gdprReducer from './gdpr'

export default {
  gdpr: gdprReducer,
  billing: billingReducer,
  segment: passthrough,
  payment_link_form: paymentLinkFormReducer,
  ...onetrustReducerObject,
  ...alertReducerObject
}
